/** Texts of manifest, permissions, audit, workflow and notifications. Pages have their own file. */
export const base = {
  name: 'Ausschreibungen',
  description:
    'Öffentliche Ausschreibungen aus Deutschland mit laufender Frist, Bearbeitung markierter Ausschreibungen bis zur Abgabe und Nachweissammlung.',
  nav: {
    tenders: 'Ausschreibungen',
    mine: 'Meine Ausschreibungen',
    evidence: 'Nachweise',
    sources: 'Quellen',
  },
  entities: { tender: 'Ausschreibung', evidence: 'Nachweis' },
  permissions: {
    tender: {
      read: {
        label: 'Ausschreibungen ansehen',
        description: 'Ausschreibungen und markierte Ausschreibungen mit Checkliste öffnen.',
      },
      write: {
        label: 'Ausschreibungen bearbeiten',
        description:
          'Ausschreibungen markieren, erfassen, Personen beteiligen, Status ändern, Checkliste und Unterlagen pflegen.',
      },
      comment: {
        label: 'Ausschreibungen kommentieren',
        description: 'Kommentare an markierten Ausschreibungen schreiben und Personen erwähnen.',
      },
      remind: {
        label: 'Wiedervorlagen an Ausschreibungen',
        description: 'Eigene Wiedervorlagen an markierten Ausschreibungen setzen.',
      },
      tasks: {
        label: 'Aufgaben an Ausschreibungen',
        description: 'Aufgaben an markierten Ausschreibungen sehen, anlegen und erledigen.',
      },
      summarize: {
        label: 'KI-Zusammenfassung erstellen',
        description:
          'Zusammenfassung und benötigte Unterlagen einer markierten Ausschreibung von der KI erstellen lassen.',
      },
    },
    evidence: {
      read: {
        label: 'Nachweise ansehen',
        description: 'Die Nachweissammlung öffnen und Nachweise herunterladen.',
      },
      write: {
        label: 'Nachweise pflegen',
        description: 'Nachweise anlegen, ändern, Dateien hochladen und löschen.',
      },
    },
    settings: {
      manage: {
        label: 'Ausschreibungen einrichten',
        description: 'Quellen ein- und ausschalten, den Import starten und Einstellungen ändern.',
      },
    },
  },
  roles: {
    reader: 'Ausschreibungen: Lesen',
    editor: 'Ausschreibungen: Bearbeiten',
    manager: 'Ausschreibungen: Verwalten',
  },
  settings: {
    sourceOev: {
      label: 'oeffentlichevergabe.de',
      description:
        'Alle Bekanntmachungen des Bundes, der Länder und Kommunen aus dem Datenservice Öffentlicher Einkauf.',
    },
    sourceNrw: {
      label: 'Vergabemarktplätze NRW',
      description:
        'Offene Daten der Vergabeportale in Nordrhein-Westfalen, auch nationale Vergaben unterhalb der EU-Schwellen.',
    },
    sourceTed: {
      label: 'TED (EU-Amtsblatt)',
      description:
        'EU-weite Bekanntmachungen mit Auftraggeber oder Ausführungsort in Deutschland aus dem Amtsblatt der EU.',
    },
    sourceBerlin: {
      label: 'Vergabeplattform Berlin',
      description: 'Neueste Bekanntmachungen des Landes Berlin, auch nationale Vergaben.',
    },
    sourceVkberlin: {
      label: 'Vergabekooperation Berlin',
      description:
        'Ausschreibungen von BVG, Berliner Wasserbetrieben, BSR, Messe Berlin, Forschungsverbund Berlin und weiteren.',
    },
    sourceBund: {
      label: 'service.bund.de',
      description: 'Ausschreibungen von Bund, Ländern und Kommunen aus dem Portal des Bundes.',
    },
    feedbackIntervalDays: {
      label: 'Tage bis zur nächsten Rückmeldungsprüfung',
      description:
        'Nach der Abgabe erinnert die App die verantwortliche Person in diesem Abstand, beim Auftraggeber nach einer Rückmeldung zu sehen.',
    },
  },
  states: {
    review: 'Prüfung',
    preparing: 'In Vorbereitung',
    submitted: 'Eingereicht',
    waiting: 'Warte auf Rückmeldung',
    won: 'Gewonnen',
    lost: 'Nicht erhalten',
    dropped: 'Verworfen',
  },
  transitions: {
    prepare: 'Angebot vorbereiten',
    submit: 'Eingereicht',
    wait: 'Auf Rückmeldung warten',
    win: 'Zuschlag erhalten',
    lose: 'Nicht erhalten',
    drop: 'Nicht bewerben',
  },
  ai: {
    summaryFiles: 'Zusammenfassung mit Vergabeunterlagen',
    summary: 'Zusammenfassung einer Ausschreibung',
  },
  notifications: {
    deadlineSoon: 'Angebotsfrist in {{days}} Tagen: {{title}}',
    participationSoon: 'Teilnahmefrist in {{days}} Tagen: {{title}}',
    deadlineToday: 'Frist endet heute: {{title}}',
    deadlineChanged: 'Frist geändert: {{title}}',
    feedbackDue: 'Rückmeldung prüfen: {{title}}',
    evidenceExpiring: 'Nachweis läuft am {{date}} ab: {{title}}',
    evidenceExpired: 'Nachweis abgelaufen: {{title}}',
  },
  audit: {
    tender: {
      mark: 'Ausschreibung markiert',
      unmark: 'Markierung zurückgenommen',
      create: 'Ausschreibung erfasst',
      update: 'Ausschreibung geändert',
      delete: 'Ausschreibung gelöscht',
      owner: 'Verantwortliche Person geändert',
      'member-add': 'Person beteiligt',
      'member-remove': 'Person entfernt',
      'feedback-checked': 'Rückmeldung geprüft',
      'documents-fetch': 'Vergabeunterlagen geladen',
      project: 'Projekt verknüpft',
    },
    checklist: {
      add: 'Punkte zur Checkliste hinzugefügt',
      update: 'Punkt der Checkliste geändert',
      remove: 'Punkt der Checkliste gelöscht',
      link: 'Nachweis verknüpft',
      unlink: 'Nachweis gelöst',
    },
    evidence: {
      create: 'Nachweis angelegt',
      update: 'Nachweis geändert',
      delete: 'Nachweis gelöscht',
    },
  },
  errors: {
    title: 'Bitte einen Titel angeben (höchstens 1000 Zeichen).',
    description: 'Die Beschreibung ist zu lang.',
    buyer: 'Bitte die Vergabestelle kürzer fassen.',
    place: 'Bitte den Ort kürzer fassen.',
    deadline: 'Bitte eine gültige Frist angeben.',
    url: 'Bitte eine gültige Adresse angeben, die mit https:// beginnt.',
    owner: 'Diese Person gibt es nicht oder sie ist nicht aktiv.',
    member: 'Diese Person gibt es nicht oder sie ist nicht aktiv.',
    project: 'Dieses Projekt gibt es nicht oder es ist für dich nicht sichtbar.',
    itemTitle: 'Bitte einen Titel angeben (höchstens 300 Zeichen).',
    evidenceTitle: 'Bitte einen Titel angeben (höchstens 300 Zeichen).',
    category: 'Die Kategorie ist zu lang.',
    date: 'Bitte ein gültiges Datum angeben.',
    responsible: 'Diese Person gibt es nicht oder sie ist nicht aktiv.',
  },
  guides: {
    tenders: {
      title: 'Ausschreibungen',
      summary:
        'Ausschreibungen finden, markieren, gemeinsam bearbeiten und nach der Abgabe die Rückmeldung im Blick behalten.',
    },
  },
};
